import { StoreProvider } from 'easy-peasy';
import React from 'react';
import { Inspector } from 'react-dev-inspector';
import { LocaleProvider } from '@meitu/xdesign-i18n';
import getStore from './store';
import { isDevelopEnv } from './utils/env';

interface RootProps {
    children: React.ReactNode;
}

const Root: React.FC<RootProps> = ({ children }) => {
    // 如之前通过 getLocaleFromURL 设置的全局 locale，在此处通过 window.locale 获取，没有则设置默认值
    const locale = (window as any).locale || 'zh-CN';

    return (
        <LocaleProvider locale={locale}>
            <StoreProvider store={getStore()}>{children}</StoreProvider>
            {isDevelopEnv() && (
                <Inspector
                    keys={['command', 'shift', 'z']}
                    disableLaunchEditor={true}
                    onClickElement={({ codeInfo }) => {
                        if (!codeInfo?.absolutePath) return;
                        const { absolutePath, lineNumber, columnNumber } = codeInfo;
                        const EDITOR_APP = 'cursor'; // 或者 'vscode'
                        window.open(`${EDITOR_APP}://file/${absolutePath}:${lineNumber}:${columnNumber}`);
                    }}
                />
            )}
        </LocaleProvider>
    );
};

export default Root;
